import { render, staticRenderFns } from "./PlatformImage.vue?vue&type=template&id=5e5c61c4&scoped=true&"
import script from "./PlatformImage.vue?vue&type=script&lang=ts&"
export * from "./PlatformImage.vue?vue&type=script&lang=ts&"
import style0 from "./PlatformImage.vue?vue&type=style&index=0&id=5e5c61c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5c61c4",
  null
  
)

export default component.exports